import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Row, List } from 'reactstrap';
import * as Icon from 'react-feather';
import Loader from '../../layouts/loader/Loader';
import matriculacionApiService from '../../services/http/matriculacionApiService';
import { getItem, setItem, removeItem, STORAGE_KEYS } from '../../services/storage';

const DetallePeticion = (props) => {
  const student = getItem(STORAGE_KEYS.STUDENT);
  const [collapse, setCollapse] = useState(false);
  const [dataApi, setDataApi] = useState('');
  const toggle = () => {
    setCollapse((prev) => !prev);
  };

  const handleRequest = (id, headquarter, email) => {
    const enrollment = {
      id,
      headquarter,
      email,
    };

    window.location.href = '/solicitudes-matricula/revision';

    if (getItem(STORAGE_KEYS.ENROLLMENT)) {
      removeItem(STORAGE_KEYS.ENROLLMENT);
    }
    setItem(STORAGE_KEYS.ENROLLMENT, enrollment);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataMatricula = await matriculacionApiService.detalleMatricula({
          headquarter: props.headquarter,
          id: props.idEnrollment,
        });
        setDataApi(dataMatricula);
      } catch (error) {
        setDataApi('');
      }
    };

    fetchData();
  }, [props.headquarter, props.idEnrollment]);

  return (
    <>
      {dataApi === '' ? (
        <Loader />
      ) : (
        <div className="mb-3">
          <div
            className="border-bottom rounded-top mb-0 px-2 py-2 pe-auto"
            role="button"
            tabIndex={0}
            onClick={toggle}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggle();
              }
            }}
            style={{ backgroundColor: '#eef5f9', cursor: 'pointer' }}
          >
            <Row>
              <Icon.Mail size={20} className="mt-2 col-1" />
              <h4 className="mt-2 col-7">
                {props.idEnrollment} - {dataApi[0].curso}{' '}
              </h4>
              <h4 className="mt-2 col-4 float-end">
                {dataApi[0].estado}{' '}
                {dataApi[0].estado.includes('secretaria') ? (
                  <Icon.Edit
                    size={20}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRequest(props.idEnrollment, student.empresaId, dataApi[0].Email);
                    }}
                  />
                ) : (
                  ''
                )}
              </h4>
            </Row>
          </div>
          {collapse && (
            <div className="border px-2 py-2">
              <List>
                {[...dataApi].sort().map((value) => (
                  <li key={value.id}>{value.descripcion}</li>
                ))}
              </List>
            </div>
          )}
        </div>
      )}
    </>
  );
};

DetallePeticion.propTypes = {
  idEnrollment: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  headquarter: PropTypes.string,
};

export default DetallePeticion;
